var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Party-Popper--Streamline-Sharp",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Party Popper Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "party-popper--hobby-entertainment-party-popper-confetti-event"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1513",
    stroke: "#fff",
    d: "M15.9226 6.5748L6.5746 15.9229L19.8176 22.9338L22.9335 19.8178L15.9226 6.5748Z",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1514",
    stroke: "#fff",
    d: "M1.0663 4.3714H3.2696",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 335",
    stroke: "#fff",
    d: "M6.7324 1.0663C6.2607 3.3053 6.6672 5.6924 7.9521 7.6763",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 336",
    stroke: "#fff",
    d: "M12.2395 6.231C10.8414 4.8329 10.5791 2.7292 11.4526 1.0663",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 337",
    stroke: "#fff",
    d: "M6.1968 11.8941C4.8083 10.5056 2.7239 10.2374 1.0665 11.0894",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1515",
    stroke: "#fff",
    d: "M13.1846 19.2439V9.3289",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1516",
    stroke: "#fff",
    d: "M18.1422 22.5489V10.9814",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolution);
export default __webpack_public_path__ + "static/media/SOLUTION.d16dee918384d22c548e7f69c61ac9f8.svg";
export { ForwardRef as ReactComponent };